import { render, staticRenderFns } from "./ServiceMenuStatusIcon.vue?vue&type=template&id=5d8ed910&scoped=true&"
import script from "./ServiceMenuStatusIcon.vue?vue&type=script&lang=ts&"
export * from "./ServiceMenuStatusIcon.vue?vue&type=script&lang=ts&"
import style0 from "./ServiceMenuStatusIcon.vue?vue&type=style&index=0&id=5d8ed910&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d8ed910",
  null
  
)

export default component.exports